import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TooltipContainer } from '../../../../Tooltip/index.js';
export const TruncatedTooltipView = ({ children, content, maxLines }) => (_jsx(TooltipContainer, { trigger: "hover", placement: "top", renderContent: () => content, children: children({
        '&&': {
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical'
        }
    }) }));
//# sourceMappingURL=index.js.map